import { http } from '@/services'

export const policyService = {
    getPolicy: (id) => {
        let url = 'policy';
        if (id) url += '/' + id;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setPolicy: (policy) => {
        let id = ('00' + parseInt(policy.index)).slice(-3);

        return http.post('policy', policy)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getPolicyFile: (policy) => {
        // use the current url location to reference policy file (don't downloaded using api domain)
        let url = window.location.protocol + '//' + window.location.host + '/views/policy/' + policy.file;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    }
};